import { ConfirmCompany } from './ConfirmCompany'

export default ConfirmCompany
